import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/messaging";

export const messagingApi = {
  listConversations: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ conversation: Record<string, unknown> }>(`${BASE}/${id}`),

  sendMessage: (conversationId: string, content: string) =>
    apiPost<{ message: Record<string, unknown> }>(`${BASE}/${conversationId}/messages`, { content }),

  markAsRead: (id: string) => apiPut<{ message: string }>(`${BASE}/${id}/read`),

  markAllAsRead: () => apiPut<{ message: string }>(`${BASE}/read-all`),

  deleteConversation: (id: string) => apiDelete<{ message: string }>(`${BASE}/${id}`),

  deleteMessage: (conversationId: string, messageId: string) =>
    apiDelete<{ message: string }>(`${BASE}/${conversationId}/messages/${messageId}`),
};
